import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import HighchartsReact from "highcharts-react-official";
import Highcharts from "highcharts";
import Grid from "@material-ui/core/Grid";
import { Button, TextField, CircularProgress, Box } from "@mui/material";
import AppContext from "../context/AppContext";
const AllMacGraph = (props) => {

  const [data, setData] = useState({});
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [isMobile]);
  const { socketData } = useContext(AppContext)
  const [loading, setLoading] = useState(false)
  function subtractTime(inputTime, hours, minutes) {

    let arr = Object.keys(data).map((mac) => ({
      name: mac,
      data: data[mac].map((entry) => [
        new Date(entry.ts).getTime(),
        entry.rssi,
        entry.asset_id, // Assuming asset_id is the correct property name
      ]),
    }))
    let [datePart, timePart] = inputTime.split(' ');

    let [hoursStr, minutesStr, secondsStr] = timePart.split(':').map(Number);

    hoursStr -= hours;
    minutesStr -= minutes;

    if (minutesStr < 0) {
      minutesStr += 60;
      hoursStr--;
    }
    if (hoursStr < 0) {
      hoursStr += 24;
    }

    let updatedTime = `${hoursStr.toString().padStart(2, '0')}:${minutesStr.toString().padStart(2, '0')}:${secondsStr}`;

    return `${datePart} ${updatedTime}`;
  }

  useEffect(() => {

    try {
      setLoading(true)
      let selected = props.selected;
      let adjusted = {}
      for (let location in selected) {

        selected[location].map((entry) => {
          entry.connected_assets.map((asset) => {
            if (adjusted.hasOwnProperty(asset.mac_id)) {

              const adjustedTimestamp = new Date(adjusted[asset.mac_id].ts).getTime();
              const currentTimestamp = new Date(asset.latest_timestamp).getTime();
              adjusted[asset.mac_id].ts = adjustedTimestamp < currentTimestamp ? new Date(adjustedTimestamp) : new Date(currentTimestamp);
            }
            else {
              adjusted = {
                ...adjusted,
                [asset.mac_id]: [
                  {
                    ts: asset.latest_timestamp,
                    rssi: asset.rssi,
                    asset_id: asset.asset_name
                  }
                ]
              }
            }
          })


        })
      }
      setData(adjusted)
      setLoading(false)

    }
    catch (err) {
      console.log(err);
    }

  }, [props.selected]);
  const adjustTimestamp = (data) => {
    const adjustedData = {};
    for (const mac in data) {
      adjustedData[mac] = data[mac].map((entry) => ({
        ...entry,
        ts: new Date(
          new Date(entry.ts).getTime() + 5 * 60 * 60 * 1000 + 30 * 60 * 1000
        ),
      }));
    }
    return adjustedData;
  };


  const options = {
    title: {
      text: "RSSI vs TIME",
    },
    xAxis: {
      type: "datetime",
      title: {
        text: "Time",
      },
    },
    yAxis: {
      title: {
        text: "RSSI",
      },
    },
    // chart: {
    //   height: 300, // Adjust the height of the chart as per your requirement
    // },
    series: Object.keys(data).map((mac) => ({
      name: mac,
      data: data[mac].map((entry) => [
        new Date(entry.ts).getTime() + 5 * 60 * 60 * 1000 + 30 * 60 * 1000,
        entry.rssi,
        entry.asset_id, // Assuming asset_id is the correct property name
      ]),
    })),
    tooltip: {
      formatter: function () {
        return `<b>${this.series.name
          }</b><br/>Timestamp: ${Highcharts.dateFormat(
            "%Y-%m-%d %H:%M:%S",
            this.x
          )}<br/>RSSI: ${this.y}`;
      },
    },
    legend: {
      layout: "vertical",
      align: "right",
      verticalAlign: "middle",
      labelFormatter: function () {
        return " (Asset ID: " + data[this.name][0].asset_id + ")";
      },
    },
    plotOptions: {
      series: {
        marker: {
          enabled: true,
          radius: 6,
        },
      },
    },

    responsive: {
      rules: [
        {
          condition: {
            maxWidth: 600, // Apply only when screen width <= 600px
          },
          chartOptions: {
            legend: {
              layout: "horizontal",
              align: "center",
              verticalAlign: "bottom", // Move legend below chart
            },
            chart: {
              height: 300, // Optional: smaller height on mobile
            },
          },
        },
      ],
    },
  };

  return (
    <div style={{ maxHeight: 1000 }}>
      <h3 style={{ color: "#07689f", fontFamily: 'sans-serif', fontSize: '20px' }}>Tracked Assets</h3>

      {/* <Grid container spacing={2} style={{ marginBottom: '12px' }}> */}
      {/* <Grid item>
          <TextField
            label="Minutes"
            type="number"
            value={minutes}
            onChange={handleMinutesChange}
          />
        </Grid> */}
      {/* <Grid item xs={12}>
          <TextField
            label="Start Time"
            type="datetime-local"
            value={dateRange.start.toISOString().slice(0, 16)}
            onChange={(e) => {
              let currentTime = new Date(e.target.value);
              let localTime = new Date(currentTime.getTime() - (currentTime.getTimezoneOffset() * 60000));
              setDateRange({ ...dateRange, start: localTime })
            }
            }
            InputLabelProps={{
              shrink: true,
              style: {
                fontWeight: 700,
                color: "#005778",
                fontSize: 15,
              },
            }}
            InputProps={{
              style: {
                fontSize: 14,
                color: "rgba( 0, 0, 0, 70% )",
                height: 40,
              },
            }}
            style={{ width: "40%", marginRight: 30 }}
            sx={{
              "& .MuiOutlinedInput-root": {
                "& fieldset": {
                  borderColor: "#50C1E9",
                },
                "&:hover fieldset": {
                  borderColor: "#50C1E9",
                },
                "&.Mui-focused fieldset": {
                  borderColor: "#50C1E9",
                },
              },
            }}
          />
          <TextField
            label="End Time"
            type="datetime-local"
            value={dateRange.end.toISOString().slice(0, 16)}
            onChange={(e) => {
              let currentTime = new Date(e.target.value);
              let localTime = new Date(currentTime.getTime() - (currentTime.getTimezoneOffset() * 60000));
              setDateRange({ ...dateRange, end: localTime })
            }
              // setDateRange({ ...dateRange, end: new Date(e.target.value) })
            }
            InputLabelProps={{
              shrink: true,
              style: {
                fontWeight: 700,
                color: "#005778",
                fontSize: 15,
              },
            }}
            InputProps={{
              style: {
                fontSize: 14,
                color: "rgba( 0, 0, 0, 70% )",
                height: 40,
              },
            }}
            sx={{
              "& .MuiOutlinedInput-root": {
                "& fieldset": {
                  borderColor: "#50C1E9",
                },
                "&:hover fieldset": {
                  borderColor: "#50C1E9",
                },
                "&.Mui-focused fieldset": {
                  borderColor: "#50C1E9",
                },
              },
            }}
            style={{ width: "40%", marginRight: 30 }}
          />

        </Grid> */}

      {/* </Grid> */}

      {loading ?
        <Box display="flex" justifyContent="center" alignItems="center" height="10vh">

          <CircularProgress size={28} />
        </Box> : Object.keys(data).length > 0 ? (
          <HighchartsReact highcharts={Highcharts} options={options} />
        ) : (
          <p>No data available</p>
        )}
    </div>
  );
};

export default AllMacGraph;
